import { connect } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { PostsType, PostsSortOrder } from '../../../../../types/posts';
import { getPostsDeviationsStreamId } from '../../../../streams/posts';
import {
  selectors as streamSelectors,
  withOffset,
} from '@wix/da-shared-react/pkg/Stream';

import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';

const mapStateToProps = (
  state: AppState,
  ownProps: { sortOrder: PostsSortOrder }
) => {
  const statusesStreamId = getPostsDeviationsStreamId({
    type: PostsType.STATUSES,
    sortOrder: ownProps.sortOrder,
  });
  const statuses = getDeviationsByIds(
    state,
    streamSelectors.getItems(state, statusesStreamId)
  );

  return {
    streamId: statusesStreamId,
    items: statuses,
    hasMore: streamSelectors.hasMore(state, statusesStreamId),
    isFetching: streamSelectors.isFetching(state, statusesStreamId),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const statusesStreamId = getPostsDeviationsStreamId({
    type: PostsType.STATUSES,
    sortOrder: ownProps.sortOrder,
  });
  return {
    fetchMore: () => dispatch(withOffset.actions.fetch(statusesStreamId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
